/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import iaAd from 'webmd-ia-ad/src/Component.vue';
import iaMediaNetLnk from 'IA-MediaNetLink/src/Component.vue';
import webmdIAModule from 'webmd-ia-module/src/Component.vue';
import instreamFeaturedModule from 'instream-featured-module/src/Component.vue';
import metric from 'webmd-vuejs-metrics';
import { createApp } from 'vue';

export default {
	computed: {

	},
	methods: {
		checkStickyAd() {
			const stickyAd = document.querySelectorAll('#ContentPane10 .ad-wrapper')[0];
			const { position } = getComputedStyle(stickyAd);
			const { bottom } = getComputedStyle(stickyAd);
			if (position === 'fixed' && bottom === '0px') {
				return true;
			}
			return false;
		},

		placeNextAdContainer(counter) {
			const artNum = this.infArticleNumber ? this.infArticleNumber : 1;
			let previousAd; let previousAdPos; let totalHeight;
			const qp = window.location.search;
			const qpCheck = window?.location?.search?.includes('bufferheight');
			this.isNewTabSpec = this.clientWidth > 767 && this.clientWidth < 1025;
			const bufferHeight = qp && qpCheck ? parseInt(qp.split('=')[1], 10) : (this.isNewTabSpec ? 300 : 100);
			// eslint-disable-next-line max-len
			const deviceHeight = window.innerHeight;
			const stickyAd = this.checkStickyAd() ? document.querySelectorAll('#ContentPane10 .ad-wrapper') : false;
			const stickyAdHeight = stickyAd && stickyAd[0] ? stickyAd[0].offsetHeight : 0;
			this.embedCheck = true;

			if (artNum && artNum === 1) {
				previousAd = `infinite-ad-${artNum}-${counter}`;
				previousAdPos = document.getElementById(previousAd).getBoundingClientRect();

				// for loading ads aggressively play with subtracting buffer height
				totalHeight = ((previousAdPos.bottom + deviceHeight) - (bufferHeight)) - stickyAdHeight;
			} else if (artNum && artNum > 1) {
				if (counter === window.adCounter) {
					previousAd = `infinite-ad-${artNum - 1}-${counter}`;
				} else {
					previousAd = `infinite-ad-${artNum}-${counter}`;
				}
				// eslint-disable-next-line max-len
				previousAdPos = document.getElementById(previousAd).offsetTop + (document.getElementById(previousAd).offsetHeight);
				totalHeight = ((previousAdPos + deviceHeight) - (bufferHeight)) - stickyAdHeight;
			}

			return totalHeight;
		},
		insertMediaNetAd() {
			const d = document.createElement('div');
			const mnetAdId = `mnet-ia-instream-${this.infArticleNumber}`;
			const mnetProps = {
				ad: {
					id: mnetAdId,
					artNum: this.infArticleNumber,
				},
			};
			this.mediaNetOrMMLink(iaMediaNetLnk, d, mnetProps);
		},
		mediaNetOrMMLink(moduleData, moduleContainer, moduleProps) {
			const infAd4 = `infinite-ad-${this.infArticleNumber}-4`;
			const targetAdEle = document.getElementById(infAd4);
			if (targetAdEle) {
				targetAdEle.insertAdjacentElement('beforebegin', moduleContainer);
				createApp(moduleData, moduleProps).use(this.$pinia).use(metric).mount(moduleContainer);
			}
		},

		insertDynamicModule() {
			const d = document.createElement('div');
			const iaModProps = {
				articleNum: this.infArticleNumber,
				moduleId: 11,
			};
			const webmdIaDynamicMod = createApp(webmdIAModule, iaModProps)
				.use(this.$pinia);

			const infAd3 = `infinite-ad-${this.infArticleNumber}-3`;
			const targetAdEle = document.getElementById(infAd3);
			
			// Ensure module is placed before 3rd ad for consistency
			if (targetAdEle && !targetAdEle.previousElementSibling?.classList.contains('webmd-ia-module')) {
				targetAdEle.insertAdjacentElement('beforebegin', d);
				d.classList.add('webmd-ia-module');
				webmdIaDynamicMod.mount(d);
			}
		},

		getArticleNumber() {
			const sel = document.getElementsByClassName('article__body');
			const artNum = sel && sel.length;
			return artNum;
		},

		insertInstreamAd(sectionEle, counter, trgHgt) {
			let offsetPos = 0;
			const adEl = document.createElement('div');
			const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
			const artNum = this.infArticleNumber ? this.infArticleNumber : 1;
			this.isNewTabSpec = this.clientWidth > 767 && this.clientWidth < 1025 && !(this.$route?.query?.ecd && this.$route?.query?.ecd.includes('conmkt'));
			// eslint-disable-next-line max-len
			const deviceHeight = window.innerHeight;
			adTargets.pg = counter;
			adTargets.ll = 1;

			if (deviceHeight < 650) {
				offsetPos = 450;
			} else {
				offsetPos = 600;
			}

			const adId = `infinite-ad-${artNum}-${counter}`;
			const instreamAd = createApp(iaAd, {
				first: counter === 1,
				last: counter === window.adCounter,
				margin: {
					top: counter === 1 && artNum > 1 ? 0 : offsetPos,
					bottom: 0,
				},
				ad: {
					pos: this.isNewTabSpec ? 141 : 2026,
					sizes: this.isNewTabSpec ? [[728, 90], [728, 92]] : [[300, 50], [300, 51], [300, 250], [300, 253],
						[320, 50], [320, 51], [320, 250]],
					id: adId,
					targets: { ...adTargets },
				},
			})

				.use(this.$pinia);
			sectionEle.insertBefore(adEl, null);
			instreamAd.mount(adEl);
		},

		// eslint-disable-next-line
		placeOutOfViewport(elWrapper, elementToPlace, mountable) {
			let insertP;
			const sections = [...elWrapper.querySelectorAll('p:not(:empty), li, table')].reduce((c, v) => {
				if (v.parentNode && v.parentNode.nodeName.toLowerCase() === 'td') {
					return c;
				}
				c.push(v);
				return c;
			}, []);

			// eslint-disable-next-line array-callback-return,consistent-return
			sections.some((s) => {
				const rect = s.getBoundingClientRect();
				if (!(rect.top >= 0
					&& rect.left >= 0
					&& rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
					&& rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				)) {
					insertP = s;
					return true;
				}
			});

			if (!insertP) {
				insertP = sections[sections.length - 1];
			}

			if (insertP) {
				insertP.dataset.adInsertElement = '';
				insertP.insertAdjacentElement('afterend', elementToPlace);

				if (mountable) {
					mountable.mount(elementToPlace);
				}
			}
		},
		recommendedModule(id, qamod) {
			const recProps = {
				margin: {
					top: 400,
					bottom: 100,
				},
				QandAmodule: qamod,
			};
			const infiniteAdId = `infinite-ad-${this.infArticleNumber}-${id}`;

			// Creating Containers and loading Recommended top picks module
			const infiniteAd = document.getElementById(infiniteAdId);
			if (infiniteAd) {
				// eslint-disable-next-line no-bitwise
				const recTpMod = `rec-tp-mod-${(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)}`;
				const rectopEle = document.createElement('div');
				rectopEle.setAttribute('id', recTpMod);
				rectopEle.setAttribute('class', 'instream-feature-module-container');
				infiniteAd.insertAdjacentElement('beforebegin', rectopEle);

				const artNum = this.getArticleNumber();

				if (artNum === 1) {
					recProps.margin.top = 2000;
				}

				createApp(instreamFeaturedModule, recProps)
					.use(this.$pinia)
					.use(metric)
					.mount(rectopEle);
			}
		},
		isInsideTable(element) {
			const self = this;
			if (element.tagName === 'TABLE' || element.tagName === 'TR' || element.tagName === 'TD') {
			  return true;
			}
			if (element.parentNode) {
			  return self.isInsideTable(element.parentNode);
			}
			return false;
		},
		placeViewportAd(val) {
			let targetHeight;
			const embeddedModules = [...document.querySelectorAll('div[id*="em-"]')];
			const busref = this.store.pagedata.omniture.s_business_reference;
			const targetSelector = 'article__body';
			const targetElements = 'p:not(:empty), li, table, h2, ul';
			let artBody = document.getElementsByClassName(targetSelector);
			const artNum = this.getArticleNumber();
			artBody = artBody[artNum - 1];
			let counter = val;
			let liFlag = true;

			if (this.infArticleNumber && this.infArticleNumber === 1) {
				targetHeight = this.placeNextAdContainer(counter);
			} else if (this.infArticleNumber && this.infArticleNumber > 1) {
				targetHeight = this.placeNextAdContainer(window.adCounter);
				window.adCounter = 9999;
			}
			const sections = [...artBody.querySelectorAll(targetElements)];
			sections.forEach((sectionEle, index) => {
				let sectionHeight;
				let isEmbedCheck = false;
				if (this.infArticleNumber && this.infArticleNumber === 1) {
					sectionHeight = sectionEle.getBoundingClientRect().bottom;
				} else if (this.infArticleNumber && this.infArticleNumber > 1) {
					sectionHeight = sectionEle.offsetTop + sectionEle.offsetHeight;
				}

				// bypass bulleted list and insert ad after 3rd bullet
				if (sectionEle.tagName === 'LI' && sectionEle.parentNode.children.length > 2 && sectionHeight > targetHeight) {
					for (let i = 0; i < sectionEle.parentNode.children.length; i++) {
						if (sectionEle.parentNode.children[i].textContent === sectionEle.textContent) {
							index = i;
							break;
						}
					}
					liFlag = index >= 2;
				}

				// do not insert ad at the starting of bullet list
				if (sectionEle.tagName === 'P' && sectionHeight > targetHeight) {
					const eleTag = sectionEle.nextElementSibling?.tagName;
					liFlag = !((eleTag === 'UL' || eleTag === 'OL'));
				}
				if (embeddedModules && embeddedModules.length > 0) {
					for (let i = 0; i < embeddedModules.length; i++) {
						const el = embeddedModules[i];
						if (el.contains(sectionEle)) {
							isEmbedCheck = true;
						}
					}
				}
				 // do not insert ad inside table
				if (this.isInsideTable(sectionEle)) {
					liFlag = false;
				}
				if (sectionHeight > targetHeight && liFlag && sectionEle.tagName != 'H2' && !isEmbedCheck) {
					counter += 1;
					this.insertInstreamAd(sectionEle, counter, sectionHeight);
					if (counter === 4 && busref && busref.toLowerCase() !== 'blog post') {
						this.insertMediaNetAd();
					}
					if (counter === 3 && busref && busref.toLowerCase() !== 'blog post') {
						this.insertDynamicModule();
					}
					targetHeight = this.placeNextAdContainer(counter);
				}
			});
			window.adCounter = counter;
		},
	},
};
